<template>
  <el-col :id="'commonCharts' + index"/>
</template>

<script>
import * as eCharts from 'echarts'

export default {
  name: "CommonCharts",
  data () {
    return {
      myChart: {}
    }
  },
  props: {
    index: {
      required: true,
      type: Number
    },
    options: {
      required: true,
      type: Object,
      default: function () {
        return {};
      }
    },
    clickMethod: {
      type: Function
    },
    outMethod: {
      type: Function
    }
  },
  mounted () {
    this.setChart();
  },
  updated () {
    if (!this.myChart) {
      this.setChart();
    }
    this.chartChange();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart = null
    }
  },
  destroyed () {
    if (this.chart) {
      this.chart = null
    }
  },
  computed: {
    optionData() {
      return this.options;
    }
  },
  methods: {
    setChart () {
      // let dom = this.$refs.myChart;
      let dom = document.getElementById("commonCharts" + this.index);
      this.myChart = eCharts.init(dom);
      this.myChart.setOption(this.optionData);
      this.myChart.on('click', this.clickMethod);
      this.myChart.on('mouseout', this.outMethod);
    },
    chartChange () {
      this.myChart.setOption(this.optionData);
    }
  },
  registerMap (mapName, geoJSON, specialAreas) {
    eCharts.registerMap(mapName, geoJSON, specialAreas)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/chart/CommonCharts.vue